"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Contains various options for report object
 *
 * Created by Hayk.Andriasyan on 5/23/2017.
 */
var ReportOptions = /** @class */ (function () {
    function ReportOptions(showIndicatorDisaggregations, hideUnspecifiedRowHierarchy, fetchNames, outSidePathHolderIds, fetchTotalCount, fetchBranchIndexes, fetchLevelIndexes, fetchColumnIndexes, needDateFormat, needNumberFormat, timezoneOffset) {
        this.showIndicatorDisaggregations = showIndicatorDisaggregations || false;
        this.hideUnspecifiedRowHierarchy = hideUnspecifiedRowHierarchy || false;
        this.fetchNames = (typeof fetchNames !== 'undefined' && fetchNames !== null) ? fetchNames : true;
        this.outSidePathHolderIds = outSidePathHolderIds || [];
        this.fetchTotalCount = fetchTotalCount || false;
        this.fetchLevelIndexes = fetchLevelIndexes || false;
        this.fetchBranchIndexes = fetchBranchIndexes || false;
        this.fetchColumnIndexes = fetchColumnIndexes || false;
        this.needDateFormat = (needDateFormat === undefined) ? true : needDateFormat;
        this.needNumberFormat = needNumberFormat || false;
        this.timezoneOffset = Number.isInteger(timezoneOffset) ? timezoneOffset : null;
    }
    ReportOptions.fromJson = function (reportOptionsJson) {
        var jsonObject = JSON.parse(reportOptionsJson);
        var reportOptions;
        reportOptions = new ReportOptions(jsonObject.showIndicatorDisaggregations, jsonObject.hideUnspecifiedRowHierarchy, jsonObject.fetchNames, jsonObject.outSidePathHolderIds, jsonObject.fetchTotalCount, jsonObject.fetchBranchIndexes, jsonObject.fetchLevelIndexes, jsonObject.fetchColumnIndexes, jsonObject.needDateFormat, jsonObject.needNumberFormat, jsonObject.timezoneOffset);
        return reportOptions;
    };
    ReportOptions.prototype.toJson = function () {
        return JSON.stringify(this);
    };
    return ReportOptions;
}());
exports.ReportOptions = ReportOptions;
//# sourceMappingURL=report-options.js.map